module.exports = __webpack_public_path__ + "static/media/toolbar_go_death_m.6d3bb264.png";